// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__RUQ38","actionsCol":"EnrolledClinics_actionsCol__QK5l_"};